/**
 * Offers various scopes and sets background and defaults in foreign stores
 * created by herbert
 */

// the whole app is presentation only so we disable jsx-ally
/* eslint jsx-a11y/onclick-has-role: 0 */
/* eslint jsx-a11y/img-has-alt: 0 */
/* eslint jsx-a11y/mouse-events-have-key-events: 0 */

import React from 'react';
//import ReactDOM from 'react-dom';

//  wichtig, damit das überhaupt geladen wird
import scopeStore from '../stores/scope-store.js'; // eslint-disable-line no-unused-vars

import scopeActions from  '../actions/scope-actions.js';
import stepActions from '../../slxstep/actions/step-actions.js';

//import Stele from './stele.jsx';

import T from '../../../nls/translate.js';

function select(n, e) {
	e.stopPropagation();
	scopeActions.select(n);
	return false;
}

const select0 = select.bind(null, 0);
const select1 = select.bind(null, 1);
const select2 = select.bind(null, 2);
const select3 = select.bind(null, 3);

const hover0 = scopeActions.hover.bind(scopeActions, 0);
const hover1 = scopeActions.hover.bind(scopeActions, 1);
const hover2 = scopeActions.hover.bind(scopeActions, 2);
const hover3 = scopeActions.hover.bind(scopeActions, 3);


export default function(children) {
	//TODO was und wie soll das mit mehreren Anwendungsbereichen gleichzeitig funktionieren?Welche Scene dann anzeigen? -- wartet immer noch auf Selux
	return (
			<div className="slx-scope">
				<div className="slx-scope__left" >
					<span>{T.current.SCOPE.HEADING}</span>
					<div className="slx-scope__chooser">
						<div className="slx-scope__chooserA"
						     onClick={select0}
						     onMouseOut={scopeActions.hover}
						     onMouseOver={hover0} >
							{T.current.SCOPE[0]}
						</div>
						<div className="slx-scope__chooserB"
						     onClick={select1}
						     onMouseOut={scopeActions.hover}
						     onMouseOver={hover1} >
							{T.current.SCOPE[1]}
						</div>
						<div className="slx-scope__chooserC"
						     onClick={select2}
						     onMouseOut={scopeActions.hover}
						     onMouseOver={hover2}>
							{T.current.SCOPE[2]}
						</div>
						<div className="slx-scope__chooserD"
						     onClick={select3}
						     onMouseOut={scopeActions.hover}
						     onMouseOver={hover3}>
							{T.current.SCOPE[3]}
						</div>
					</div>
					<div className="slx-scope__next" onClick={stepActions.next} />
				</div>
				<div className="slx-scope__right" >
					{children}
				</div>
			</div>
	);
}
